import Team1 from './Team1'
export default Team1
